export enum AvatarApiErrorTypes {
  LoadAvatarError,
  LoadBlendStateError,
}

export class AvatarApiError {
  constructor(public type: AvatarApiErrorTypes, public error: Error) {}
}
